import _format from 'date-fns/format'
export const dateFormatted = date => _format(date, 'MM.DD.YYYY')



// WEBPACK FOOTER //
// ./src/util/date.js